import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "steps__step-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "h4 h4--b" }, " Provide all available project specifics ", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-24" }, " All fields are required unless indicated as optional. ", -1 /* HOISTED */)
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = {
  class: "button button--fill",
  type: "submit"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("form", {
      class: "form form--fixed-fields",
      onSubmit: _withModifiers($setup.updateForm, ["prevent"])
    }, [
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.project_name,
        type: "text",
        "input-id": "project-name",
        name: "project-name",
        label: "Project Name",
        "sub-label": "Number and client code will be added automatically",
        required: true,
        errors: $setup.form_errors.project_name || null,
        "onUpdate:value": _cache[0] || (_cache[0] = new_value => $setup.form_fields.project_name = new_value)
      }, null, 8 /* PROPS */, ["value", "errors"]),
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.project_type,
        type: "select",
        "input-id": "project-type",
        name: "project-type",
        label: "Project Type",
        options: $setup.project_types,
        required: true,
        errors: $setup.form_errors.project_type || null,
        "onUpdate:value": _cache[1] || (_cache[1] = new_value => $setup.form_fields.project_type = new_value)
      }, null, 8 /* PROPS */, ["value", "options", "errors"]),
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.project_location,
        type: "multilevel-dropdown",
        "input-id": "project-location",
        name: "project-location",
        label: "Project Location",
        placeholder: "Search",
        options: $setup.project_locations,
        required: true,
        errors: $setup.form_errors.project_location || null,
        "onUpdate:value": _cache[2] || (_cache[2] = value => $setup.form_fields.project_location = value)
      }, null, 8 /* PROPS */, ["value", "options", "errors"]),
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.project_coordinates,
        type: "text",
        "input-id": "project-coordinates",
        name: "project-coordinates",
        label: "Project Coordinates",
        "sub-label": "Right-click in Google Maps and choose top option",
        required: true,
        errors: $setup.form_errors.project_coordinates || null,
        "onUpdate:value": _cache[3] || (_cache[3] = new_value => $setup.form_fields.project_coordinates = new_value)
      }, null, 8 /* PROPS */, ["value", "errors"]),
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.intended_use,
        type: "select",
        "input-id": "intended-use",
        name: "intended-use",
        label: "Intended Use",
        options: $setup.intended_uses,
        required: true,
        errors: $setup.form_errors.intended_use || null,
        "onUpdate:value": _cache[4] || (_cache[4] = new_value => $setup.form_fields.intended_use = new_value)
      }, null, 8 /* PROPS */, ["value", "options", "errors"]),
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.kick_off,
        type: "dateinputs",
        "input-id": "kick-off",
        name: "kick-off",
        label: "Kick off date",
        "sub-label": "DD / MM / YYYY",
        required: true,
        errors: $setup.form_errors.kick_off || null,
        "onUpdate:value": _cache[5] || (_cache[5] = new_value => $setup.form_fields.kick_off = new_value)
      }, null, 8 /* PROPS */, ["value", "errors"]),
      _createVNode($setup["InputComponent"], {
        modelValue: $setup.form_fields.completion_date,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.form_fields.completion_date) = $event)),
        value: $setup.form_fields.completion_date,
        type: "dateinputs",
        "input-id": "completion-date",
        name: "completion-date",
        label: "Target completion date",
        "sub-label": "DD / MM / YYYY",
        required: true,
        errors: $setup.form_errors.completion_date || null,
        "onUpdate:value": _cache[7] || (_cache[7] = new_value => $setup.form_fields.completion_date = new_value)
      }, null, 8 /* PROPS */, ["modelValue", "value", "errors"]),
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.project_description,
        type: "textarea",
        "input-id": "project-description",
        name: "project-description",
        label: "Project Description",
        "group-class": "form__set--fixed-wide",
        "char-limit": "500",
        "sub-label": "Optional",
        required: true,
        errors: $setup.form_errors.project_description || null,
        "onUpdate:value": _cache[8] || (_cache[8] = new_value => $setup.form_fields.project_description = new_value)
      }, null, 8 /* PROPS */, ["value", "errors"]),
      _createElementVNode("button", _hoisted_5, " Save " + _toDisplayString($props.stepTitle), 1 /* TEXT */)
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4)
  ]))
}